import { Element } from 'slate';
import { BlockElement } from '../../types';

export const inlineLinkType = 'inlineLink';

// type guard
export const isInlineLink = (element: Element): element is BlockElement =>
  element?.type === inlineLinkType;
